/**
 * ### pastePlainText
 *
 * @description
 * Pastes plain text at the current cursor position in a contentEditable element,
 * respecting the maxLength constraint if provided
 *
 * @example
 * pastePlainText(clipboardEvent); // Pastes text from clipboard at current cursor position
 * pastePlainText(clipboardEvent, 10); // Pastes text respecting maxLength of 10
 *
 * @param event - The clipboard event containing the text to paste
 * @param maxLength - Optional maximum length constraint for the content
 */
const pastePlainText = (event: React.ClipboardEvent<HTMLElement>, maxLength?: number): void => {
  const selection = window.getSelection();
  if (selection && selection.rangeCount > 0) {
    // Get plain text from clipboard
    const plainText = event.clipboardData.getData('text/plain');

    const range = selection.getRangeAt(0);

    // Delete the selected content first
    range.deleteContents();

    let textToInsert = plainText;

    if (maxLength !== undefined) {
      // Get the current content after deletion
      const container = range.startContainer.parentElement || range.startContainer;
      const currentContent = container.textContent || '';
      const availableSpace = maxLength - currentContent.length;

      if (availableSpace <= 0) {
        // No space available, don't paste anything
        return;
      }

      // Trim the pasted text to fit within maxLength
      textToInsert = plainText.substring(0, availableSpace);
    }

    range.insertNode(document.createTextNode(textToInsert));

    // Move cursor to end of inserted text
    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);
  }
};

export default pastePlainText;
